import { Api } from './BaseApi'
import { IAsset } from '../../types/Asset/IAsset';

const AssetApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getAssets: build.query<IAsset[], {contactId?:number,locationId?:number,companyId?:number}>({
            query: ({contactId,locationId,companyId}) => `Asset/?contactId=${contactId}&locationId=${locationId || 0}&companyId=${companyId || 0}`,
            providesTags: ["GetAssets"],
      }),
  }),
  overrideExisting: false,
})

export { AssetApi };